export type ProjectTakhmeenAmountRecord = {
  committedAmount?: unknown;
  paidAmount?: unknown;
};

/** Pending pledge balance: committed minus paid, floored at zero. */
export const computeProjectTakhmeenPending = (
  record: ProjectTakhmeenAmountRecord | Record<string, unknown> | null | undefined
): number => {
  const committed = Number(record?.committedAmount ?? 0);
  const paid = Number(record?.paidAmount ?? 0);
  if (Number.isNaN(committed) || Number.isNaN(paid)) return 0;
  return Math.max(0, committed - paid);
};
